import { AxiosInstance } from 'axios';
import axios from 'axios';
import qs from 'query-string';
import {
  handleAccess,
  handleError,
  markCalculationRequest,
  unmarkCalculationRequest,
  unmarkCalculationRequestFromError,
} from 'services/controllers/interceptors';

import { getVariable } from 'helpers/environment.utils';

export const businessPlanAxios = init();

function init(): AxiosInstance {
  const client = axios.create({
    baseURL: getVariable('REACT_APP_ENV_API_BUSINESSPLAN_BASE'),
    paramsSerializer: (params) => qs.stringify(params),
  });

  client.interceptors.request.use(handleAccess);
  client.interceptors.request.use(markCalculationRequest);
  client.interceptors.response.use(undefined, handleError());
  client.interceptors.response.use(
    (response) => {
      unmarkCalculationRequest(response.config);
      return response;
    },
    unmarkCalculationRequestFromError,
  );

  return client;
}
